import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import StlViewerPage from './StlViewerPage';

export const mapStateToProps = (state: AppState) => {
  return {
    signedUrlStl: state.UserRxFormData.signedUrlStl
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {

  };
};

const StlViewerPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(StlViewerPage);

export default StlViewerPageContainer;



// WEBPACK FOOTER //
// ./src/components/stlViewer/StlViewerPageContainer.tsx